import { Enzyme as EnzymeData } from '@interfaces/enzyme'

export default class ModelEnzyme {
    private data: EnzymeData

    constructor(data: EnzymeData) {
        this.data = data
    }

    get id(): string {
        return this.data.id
    }

    get title(): string {
        return this.data.title
    }

    get type(): string {
        return this.data.type
    }
}
